import { Icon } from "@mdi/react";
import React from "react";

import { mdiArrowLeft, mdiPencil } from "@mdi/js";
import { Button } from "antd";
import { extractYouTubeVideoId } from "utils/youtubeUtils";

import { Tooltip } from "components/base";

import styles from "../../styles/tutorialViews.module.scss";
import { TutorialItem } from "../../types";

interface TutorialVideoViewProps {
  tutorial?: TutorialItem;
  videoId: string;
  onBack: () => void;
  onEdit?: () => void;
  canEdit: boolean;
}

const TutorialVideoView: React.FC<TutorialVideoViewProps> = ({
  tutorial,
  onBack,
  onEdit,
  canEdit
}) => {
  if (!tutorial) {
    return (
      <div className={styles.tutorialVideoView} data-testid="tutorial-video-view">
        <div className={styles.headerContainer}>
          <Button
            type="text"
            onClick={onBack}
            className={styles.backButton}
            data-testid="tutorial-video-back-button">
            <Icon path={mdiArrowLeft} size="2.75rem" />
          </Button>
          <h2 data-testid="tutorial-not-found">Tutorial Not Found</h2>
        </div>
        <div className={styles.videoContainer}>
          <div className={styles.videoPlaceholder}>Tutorial not available</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tutorialVideoView} data-testid="tutorial-video-view">
      <div className={styles.headerContainer}>
        <Button
          type="text"
          onClick={onBack}
          className={styles.backButton}
          data-testid="tutorial-video-back-button">
          <Icon path={mdiArrowLeft} size="2.75rem" />
        </Button>
        <h2 data-testid="tutorial-video-title">{tutorial.title}</h2>

        {canEdit && onEdit && (
          <Tooltip title="Edit Video">
            <Button
              type="text"
              onClick={onEdit}
              className={styles.editButton}
              data-testid="tutorial-video-edit-button">
              <Icon path={mdiPencil} size="2.75rem" />
            </Button>
          </Tooltip>
        )}
      </div>

      <div className={styles.videoContainer}>
        {(() => {
          const videoId = extractYouTubeVideoId(tutorial.videoUrl);
          return videoId ? (
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              width="100%"
              allowFullScreen
              data-testid="tutorial-video-preview"
              title={tutorial.title || "Tutorial Video Preview"}></iframe>
          ) : (
            <div className={styles.videoPlaceholder}>
              <p>Video not available</p>
            </div>
          );
        })()}
        {tutorial.categories && (
          <div
            className={styles.detailsContainer}
            data-testid="tutorial-video-categories">
            {tutorial.categories.length > 1 ? "Categories: " : "Category: "}
            {tutorial.categories.join(", ")}
          </div>
        )}
      </div>
    </div>
  );
};

export default TutorialVideoView;
